"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PanelGroup = require("react-bootstrap/lib/PanelGroup");

var _PanelGroup2 = _interopRequireDefault(_PanelGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** AccordionItem is merely a wrapper for <Panel> when used in conjuction with React-Bootstrap's <Accordion> component.
 AccordionItem accepts all Panel properties, except for "bsClass". <a href="https://react-bootstrap.github.io/components/panel/#panels-accordion">Accordion implementation</a>. */

var AccordionContainer = function AccordionContainer(_ref) {
  var htmlId = _ref.htmlId,
      children = _ref.children,
      independent = _ref.independent,
      other = _objectWithoutProperties(_ref, ["htmlId", "children", "independent"]);

  var accordionChildren = function accordionChildren() {
    var newProps = {
      headerrole: "tab",
      panelrole: "tabpanel"
    };
    if (Array.isArray(children)) {
      return children.map(function (child) {
        return _react2.default.cloneElement(child, Object.assign({
          key: child.props.eventKey
        }, newProps));
      });
    } else {
      return _react2.default.cloneElement(children, Object.assign({}, newProps));
    }
  };

  return _react2.default.createElement(
    _PanelGroup2.default,
    Object.assign({}, other, {
      id: htmlId,
      bsClass: "accordion-group",
      accordion: !independent
    }),
    accordionChildren()
  );
};

AccordionContainer.propTypes = {
  children: _propTypes2.default.node,
  htmlId: _propTypes2.default.string.isRequired,
  independent: _propTypes2.default.bool
};

AccordionContainer.defaultProps = {
  independent: false
};

exports.default = AccordionContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/AccordionContainer.js
// module id = 577
// module chunks = 0